import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import useReveal from "@/hooks/useReveal";
import { ArrowRight } from "@phosphor-icons/react";

export default function Insights() {
  const ref = useReveal();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/insights", { params: { published_only: true } }).then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <section id="insights" ref={ref} data-testid="insights" className="reveal section border-b border-[color:var(--line)] bg-[color:var(--paper-alt)]">
      <div className="container-x">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-6">
          <div>
            <div className="eyebrow">Insights</div>
            <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02] max-w-2xl">
              Notes from the delivery floor.
            </h2>
          </div>
          <Link to="/blog" data-testid="insights-view-all" className="btn-ghost text-sm py-2.5 px-4">
            View all posts <ArrowRight size={14} weight="bold" />
          </Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.slice(0, 6).map((p) => (
            <Link
              to={`/insights/${p.slug}`}
              key={p.id}
              data-testid={`insight-${p.slug}`}
              className="card-line p-6 flex flex-col group"
            >
              <div className="aspect-[16/9] border border-[color:var(--line)] bg-white overflow-hidden">
                {p.cover_image_url ? (
                  <img src={p.cover_image_url} alt={p.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full grid-bg opacity-80 flex items-end p-4">
                    <span className="font-display font-black text-2xl text-[color:var(--brand)]">Maxine</span>
                  </div>
                )}
              </div>
              <div className="mt-5 flex flex-wrap gap-2">
                {(p.tags || []).slice(0, 3).map((t) => (
                  <span key={t} className="font-mono text-[10px] uppercase tracking-widest border border-[color:var(--line)] px-2 py-1 text-neutral-600">{t}</span>
                ))}
              </div>
              <h3 className="mt-3 font-display font-bold text-xl leading-snug group-hover:text-[color:var(--brand)] transition-colors duration-200">{p.title}</h3>
              <p className="mt-2 text-sm text-neutral-600 line-clamp-3">{p.excerpt}</p>
              <span className="mt-4 pt-4 border-t border-[color:var(--line)] font-mono text-xs uppercase tracking-widest text-[color:var(--brand)] flex items-center gap-2">
                Read <ArrowRight size={14} weight="bold" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
